<template>
  <div class="TheBreadcrumb">
    <router-link v-for="(part, index) in routeParts"
                 :key="index" :to="part.path" v-if="part.name">{{ part.name }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'TheBreadcrumb',
  computed: {
    routeParts() {
      return this.$route.matched.map(r => ({ path: r.path.charAt(0) === '/' ? r.path : `/${r.path}`, name: r.name }));
    },
  },
};
</script>

<style lang="scss">
  .TheBreadcrumb {
    position: relative;
    margin-bottom: 1em;
    font-size: smaller;
    a {
      margin-right: .5em;
    }
    a::after {
      content: " > ";
      background: #fff;
      color: #333;
    }
    a:only-child::after  {
      display: none;
    }
    a:last-child::after {
      display: none;
    }
  }
</style>
